// src/url-builder.ts
var UrlBuilder = class _UrlBuilder {
  url;
  constructor(url) {
    this.url = new URL(url);
  }
  static Url = (url) => new _UrlBuilder(url);
  toString = () => this.url.toString();
  appendPathSegment = (pathSegment, addTrailingSlash = true) => {
    if (!pathSegment) {
      return this;
    }
    if (typeof pathSegment === "number") {
      pathSegment = pathSegment.toString();
    }
    if (pathSegment === "/") {
      return this;
    }
    this.url.pathname = `${this.stripTrailingSlash(this.url.pathname)}/${this.stripSlashes(pathSegment)}${addTrailingSlash ? "/" : ""}`;
    return this;
  };
  setQueryParam = (name, value) => {
    if (value === null) {
      this.url.searchParams.delete(name);
    } else if (typeof value === "string") {
      this.url.searchParams.set(name, value);
    }
    return this;
  };
  replacePathname = (replace) => {
    let newPathname = "";
    if (typeof replace === "function") {
      newPathname = replace(this.url.pathname);
    } else {
      newPathname = replace;
    }
    this.url.pathname = `${this.stripTrailingSlash(newPathname)}/`;
    return this;
  };
  stripLeadingSlash = (s) => s.replace(/^\//, "");
  stripTrailingSlash = (s) => s.replace(/\/$/, "");
  stripSlashes = (s) => s.replace(/^\/|\/$/g, "");
};

// src/relative-url-builder.ts
var RelativeURLBuilder = class _RelativeURLBuilder extends UrlBuilder {
  constructor(url) {
    super(`http://placeholder${url}`);
  }
  static Url = (url) => new _RelativeURLBuilder(url);
  toString = () => {
    return `${this.url.pathname}${this.url.search}`;
  };
};
export {
  RelativeURLBuilder,
  UrlBuilder
};
